import axios from "@lib/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";

export interface Inputs {
  name: string;
  isNewsletter?: boolean;
  requiresReview?: boolean;
  tags: [];
  contentGroups: [];
  recipients: [];
  active?: boolean;
}

interface Props {
  listId?: string;
  onSuccess?: (data: AxiosResponse) => void;
  onError?: (error: AxiosError) => void;
}

export const useSaveList = ({ listId, onSuccess, onError }: Props) => {
  const queryClient = useQueryClient();
  const {
    isPending,
    isError,
    error,
    mutate: onSaveList,
  } = useMutation({
    mutationFn: async ({
      id,
      tags,
      contentGroups,
      recipients: recipientIds,
      ...data
    }: Inputs) => {
      if (tags) data.tagIds = tags.map((item) => item.value);
      if (contentGroups)
        data.contentGroupIds = contentGroups.map((item) => item.value);
      if (recipientIds) data.recipientIds = recipientIds;

      if (listId) return axios.patch(`/lists/${listId}`, data);
      return axios.post("/lists", data);
    },
    onSuccess: (data) => {
      if (listId) queryClient.invalidateQueries({ queryKey: ["list", listId] });
      if (onSuccess) onSuccess(data);
    },
    onError,
  });

  return { onSaveList, isPending, isError, error };
};
